import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=35b7e7cc&"
import script from "./ProductUnit.vue?vue&type=script&lang=js&"
export * from "./ProductUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports